import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'ja', 'ko', 'vi', 'id', 'th', 'es', 'de', 'ru', 'fr', 'tr'],

  // Used when no locale matches
  defaultLocale: 'en',

  // Always use a prefix for all locales (including default)
  localePrefix: 'always',

  // Every production URL has an explicit locale prefix. Avoid setting a
  // response cookie that would make otherwise-public pages user-specific.
  localeCookie: false
})

// Export locales array for use in generateStaticParams and other places
// This ensures consistency across the codebase
export const locales = routing.locales
export const defaultLocale = routing.defaultLocale

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
